export default (() => ({
  root: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'center',
  },
}));
